export default __webpack_public_path__ + "static/media/worried.d53dbf1b.jpg";